import { getResourcePath, trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import { useStateMachineContext } from '@spotahome/landings-common/src/context/StateMachineContext';

import './Success.scss';

const Success = () => {
  const {
    send,
    payload: { name, email, sosNumber }
  } = useStateMachineContext();

  return (
    <div className="success-step">
      <p className="success-step__header">
        {trans('contact-us.success.title', {
          name
        })}
      </p>

      <div className="success-step__image">
        <img
          src={getResourcePath('/images/contact-us/contact-form-success.svg')}
          alt="success"
        />
      </div>

      <p className="success-step__priority">
        {trans('contact-us.success.priority.high')}
      </p>

      <p className="success-step__reach-email">
        {trans('contact-us.success.email', {
          email
        })}
      </p>

      {sosNumber && (
        <p className="success-step__sos-number">
          {trans('contact-us.success.sos-number')} {sosNumber}
        </p>
      )}

      <Button
        color="primary"
        size="large"
        fullWidth
        onClick={() => send('END')}
        className="contact-us-form__button-success"
      >
        {trans('contact-us.success.button')}
      </Button>
    </div>
  );
};

export default Success;
